import React, { useEffect, useState } from "react";
import DTOMarkasComplete from "./DTOMarkasComplete";
import MarkasCompletePresenter from "./MarkasCompletePresenter";
import _ from "lodash";
import { trainingServices } from "../../../../api/services/trainingServices";
import { toast } from "react-hot-toast";
import EmpTrainingController from "../../../../domain/myProfile/training/EmployeeTraining/EmpTrainingController";
import DTOEmpTrainingDetails from "../EmpTrainingDetails/DTOEmpTrainingDetails";
import DTOEmptraining from "../../../../domain/myProfile/training/EmployeeTraining/DTOEmptraining";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import { setEmpTrainingData } from "../../../../infra/aggregates/myProfile/TrainingAggregates/getEmpTrainingSlice";
import { useTranslation } from "react-i18next";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  traineesData: any;
}

const MarkasCompleteController = ({
  isModalOpen,
  closeModal,
  traineesData,
}: ModalInterface) => {
  const { t, i18n } = useTranslation();
  const [emptrainingDatas, setEmptrainingDatas] = useState("");
  const [refresh, setreFresh] = useState(false);
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();
  const store_training: any = useAppSelector(
    (state) => state.getEmpTrainingSlice.empTrainingData
  );

  const loadtrainees: any = _.map(traineesData?.trainees, (data: any) => {
    const s = 0;
    const rowData: any = {
      id: data?.emp_id,
      empId: data?.emp_id,
      avatar: data?.employee ? data?.employee?.profile_pic : "",
      employee: data?.employee
        ? data?.employee?.first_name + " " + data?.employee?.last_name
        : "--",
      designation: data?.employee?.emp_job_detail
        ? data?.employee?.emp_job_detail?.designation?.name
        : "--",
      score: "",
      status: data?.status == 1 ? true : false,
      training_id: data?.training_id,
    };
    return rowData;
  });

  const handlePayload = async (data: any) => {
    const response: any = await trainingServices.createMarkasComplete(data);
    if (response.response == "success") {
      toast.success(t("Marked Successfully"));

      const response2: any = await trainingServices.updateTrainingStatus(
        3,
        data.markascomplete[0]?.training_id
      );
      //setreFresh(true);
      const temp = [...store_training];
      const templist: any = _.filter(temp, (data: any) => {
        return data.id !== response2?.data?.id;
      });
      templist.push(response2?.data);
      dispatch(setEmpTrainingData(templist));
    }
  };

  return (
    <>
      <DTOMarkasComplete />
      <MarkasCompletePresenter
        trans={t}
        i18n={i18n}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trainees_DataList={loadtrainees}
        setPayload={handlePayload}
      />
    </>
  );
};
export default MarkasCompleteController;
